import { render, staticRenderFns } from "./EmailContentPopup.vue?vue&type=template&id=d3847172&scoped=true&"
import script from "./EmailContentPopup.vue?vue&type=script&lang=ts&"
export * from "./EmailContentPopup.vue?vue&type=script&lang=ts&"
import style0 from "./EmailContentPopup.vue?vue&type=style&index=0&id=d3847172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3847172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3847172')) {
      api.createRecord('d3847172', component.options)
    } else {
      api.reload('d3847172', component.options)
    }
    module.hot.accept("./EmailContentPopup.vue?vue&type=template&id=d3847172&scoped=true&", function () {
      api.rerender('d3847172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/EmailContentPopup.vue"
export default component.exports